import { Component, Input, ViewChild, ComponentFactoryResolver, Inject, Type, Output, EventEmitter, ViewContainerRef, AfterViewInit } from '@angular/core';
import { AttributeModel } from './model/attribute.model';
import { DynamicItemConfigService } from './service/dynamic-item-config.service';
import { DynamicItemConfig } from './model/dynamic-item-config';
import { DynamicItem } from './dynamic-item';
import { DynamicItemMapping } from './model/dynamic-item-mapping';
import { OptionModel } from './model/option.model';
import { ProcessModel } from './model/process.model';
import { DefaultComponent } from '../processes/process/dynamicProcess/default/defult.component';

@Component({
  selector: 'app-dynamic',
  template: `<ng-template #dynamicComp></ng-template>`
})
export class DynamicComponent implements AfterViewInit {

  @Input() attribute: AttributeModel
  @Input() section: AttributeModel
  @Input() parent: AttributeModel
  @Input() process: ProcessModel
  @Input() envOptions: OptionModel[] = []
  @Output() onEmit: EventEmitter<any> = new EventEmitter()

  @ViewChild('dynamicComp', { read: ViewContainerRef }) 
  viewContainerRef

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(DynamicItemConfigService) private config: DynamicItemConfig) { }

  ngAfterViewInit() {
    this.loadComponent()
  }

  loadComponent() {
    let componentFactory = this.componentFactoryResolver
      .resolveComponentFactory(this.getType());

    let componentRef = this.viewContainerRef.createComponent(componentFactory);
    let refInstance = (<DynamicItem>componentRef.instance)
    refInstance.attribute = this.attribute;
    refInstance.parent = this.parent;
    refInstance.section = this.section;
    refInstance.process = this.process;
    refInstance.envOptions = this.envOptions;
    refInstance.onEmit = this.onEmit;

    console.log(this.viewContainerRef)

    componentRef.hostView.detectChanges();
  }

  getType(): Type<any> {
    if (!this.attribute) {
      throw new Error(`The attribute cannot be null.`);
    }

    let found = this.config.mapping
      .find(key => key.name.toUpperCase() == this.attribute.type.toUpperCase())

    this.validate(found);

    if(!found) {
      return DefaultComponent
    }

    return found.component
  }

  private validate(found: DynamicItemMapping) {
    if (!found && this.attribute && !this.attribute.type) {
      throw new Error(`The attribute ${this.attribute.key} doesn't have a type.`);
    }
    else if (!this.attribute) {
      throw new Error(`The attribute cannot be null.`);
    }
  }
}